module.exports = __webpack_public_path__ + "images/help_v2/icon-pdf-30c7395cad35933a4de7f10d115f7a86.png";